export default __webpack_public_path__ + "static/media/rebobinadeira.bf6b205f.png";